import PropTypes from 'prop-types';
import { ButtonIcon } from './styles';
import TrashIcon from '../../../../assets/icons/trash.svg?react';
import { theme } from '../../style/theme';
import { FileItem, FileLabel, FileSize, RightContainer } from '../ui/files/styles';
import { humanFileSize } from '../ui/files/humanFileSize';

const File = ({ file, onClose, maxSize }) => {
    const isOversized = () => file?.size > maxSize;

    return (
        <FileItem>
            <FileLabel warning={isOversized()}>{file.name}</FileLabel>
            <RightContainer>
                <FileSize warning={isOversized()}>{humanFileSize(file?.size)}</FileSize>
                <ButtonIcon onClick={() => onClose(file)}>
                    <TrashIcon color={isOversized() ? theme.color.orange.main : theme.color.black.main} />
                </ButtonIcon>
            </RightContainer>
        </FileItem>
    );
};

File.propTypes = {
    file: PropTypes.shape({ name: PropTypes.string, size: PropTypes.number }).isRequired,
    onClose: PropTypes.func,
    maxSize: PropTypes.number,
};

export default File;
